
export enum TableColumnType{
    input,
    number,
    text,
    currency
}

export interface TableColumn {
    key: string;
    displayName: string;
    type: TableColumnType;
    isDisplayed: boolean;
    isFilterEnabled: boolean;
    isBoldText: boolean;
};